import { defineStore } from 'pinia';
import { onRequestDefaultError, requests, removeNulls } from '🔗/utils/requests';
// import stores from '🔗/stores';

const useShowcaseApi = defineStore('showcase-api', {
    state: () => ({
        defaultWidgetCover: {
            resized: new URL(`🔗/assets/img/showcase/widgets/resized.jpg`, import.meta.url).href,
            original: new URL(`🔗/assets/img/showcase/widgets/original.jpg`, import.meta.url).href
        }
    }),
    getters: {
        section: (state) => ({
            list: state.listSection,
            get: state.getSection,
            add: state.addSection,
            update: state.updateSection,
            remove: state.removeSection
        }),
        widget: (state) => ({
            preview: state.previewWidgets,
            list: state.listWidget,
            get: state.getWidget,
            add: state.addWidget,
            update: state.updateWidget,
            remove: state.removeWidget,
            updateCover: state.updateWidgetCover,
            removeCover: state.removeWidgetCover,
            updateHeaderCover: state.updateWidgetHeaderCover,
            removeHeaderCover: state.removeWidgetHeaderCover,

            track: {
                add: state.addWidgetTrack,
                setPosition: state.setWidgetTrackPosition,
                remove: state.removeWidgetTrack
            },
            playlist: {
                add: state.addWidgetPlaylist,
                setPosition: state.setWidgetPlaylistPosition,
                remove: state.removeWidgetPlaylist
            },
            release: {
                add: state.addWidgetRelease,
                setPosition: state.setWidgetReleasePosition,
                remove: state.removeWidgetRelease
            },
            artist: {
                add: state.addWidgetArtist,
                setPosition: state.setWidgetArtistPosition,
                remove: state.removeWidgetArtist
            }
        })
    },
    actions: {
        // Section
        async listSection(params = {}) {
            try {
                const result = await this.$http({
                    method: 'GET',
                    url: '/showcase/sections/list',
                    params,
                    // signal: requests.signal('showcase-section-list')
                });

                if (result.status === 200) {
                    const { data } = result;

                    return data;
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },
        async getSection(id) {
            try {
                const result = await this.$http({
                    method: 'GET',
                    url: `/showcase/section/${ id }`,
                    signal: requests.signal('showcase-section-get', id)
                });

                if (result.status === 200) {
                    const { data } = result;

                    return data;
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },
        async addSection(data) {
            try {
                const result = await this.$http({
                    method: 'POST',
                    url: '/showcase/section/create',
                    data: removeNulls(data),
                    // signal: requests.signal('release-create')
                });

                if (result.status === 200) {
                    const { data } = result;

                    return data;
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },
        async updateSection(id, data) {
            try {
                const result = await this.$http({
                    method: 'PUT',
                    url: `/showcase/section/${ id }`,
                    data,
                    signal: requests.signal('showcase-section-update', id)
                });

                if (result.status === 200) {
                    const { data } = result;

                    return data;
                } else {
                    onRequestDefaultError({ response: result });
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },
        async removeSection(id) {
            try {
                const result = await this.$http({
                    method: 'DELETE',
                    url: `/showcase/section/${ id }`,
                    signal: requests.signal('showcase-section-remove', id)
                });

                if (result.status === 200) {
                    const { data } = result;

                    return data;
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },

        // Widget
        async previewWidgets(params = {}, code) {

            try {
                const result = await this.$http({
                    method: 'GET',
                    url: '/showcase/widget/list/preview',
                    params,
                    signal: requests.signal(`showcase-widget-preview-${code || ''}`)
                });

                if (result.status === 200) {
                    const { data } = result;

                    return data;
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },
        async listWidget(params = {}, code) {
            try {
                const result = await this.$http({
                    method: 'GET',
                    url: '/showcase/widget/list',
                    params,
                    signal: requests.signal(`showcase-widget-${code || ''}`)
                });

                if (result.status === 200) {
                    const { data } = result;

                    return data;
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },
        async getWidget(id) {
            try {
                const result = await this.$http({
                    method: 'GET',
                    url: `/showcase/widget/${ id }`,
                    signal: requests.signal('showcase-widget-get', id)
                });

                if (result.status === 200) {
                    const { data } = result;

                    return data;
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },
        async addWidget(data) {
            try {
                const result = await this.$http({
                    method: 'POST',
                    url: '/showcase/widget/create',
                    data: removeNulls(data),
                    // signal: requests.signal('release-create')
                });

                if (result.status === 200) {
                    const { data } = result;

                    return data;
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },
        async updateWidget(id, data) {
            try {
                const result = await this.$http({
                    method: 'PUT',
                    url: `/showcase/widget/${ id }`,
                    data,
                    signal: requests.signal('showcase-widget-update', id)
                });

                if (result.status === 200) {
                    const { data } = result;

                    return data;
                } else {
                    onRequestDefaultError({ response: result });
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },
        async removeWidget(id) {
            try {
                const result = await this.$http({
                    method: 'DELETE',
                    url: `/showcase/widget/${ id }`,
                    signal: requests.signal('showcase-widget-remove', id)
                });

                if (result.status === 200) {
                    const { data } = result;

                    return data;
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },
        async removeWidgetCover(id) {
            const formData = new FormData();

            try {
                const result = await this.$http({
                    method: 'POST',
                    url: `/showcase/widget/${id}/cover/`,
                    formData,
                    contentType: 'multipart/form-data',
                    signal: requests.signal('showcase-section-widget-cover', id)
                });

                if ([200, 201].indexOf(result.status) !== -1) {
                    return result.data;
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },
        async updateWidgetCover(id, file) {
            const formData = new FormData();
            formData.append('cover', file);

            try {
                const result = await this.$http({
                    method: 'POST',
                    url: `/showcase/widget/${id}/cover/`,
                    formData,
                    contentType: 'multipart/form-data',
                    signal: requests.signal('showcase-section-widget-cover', id)
                });

                if ([200, 201].indexOf(result.status) !== -1) {
                    return result.data;
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },
        async removeWidgetHeaderCover(id) {
            const formData = new FormData();

            try {
                const result = await this.$http({
                    method: 'POST',
                    url: `/showcase/widget/${id}/header-cover/`,
                    formData,
                    contentType: 'multipart/form-data',
                    signal: requests.signal('showcase-section-widget-header-cover', id)
                });

                if ([200, 201].indexOf(result.status) !== -1) {
                    return result.data;
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },
        async updateWidgetHeaderCover(id, file) {
            const formData = new FormData();
            formData.append('headerCover', file);

            try {
                const result = await this.$http({
                    method: 'POST',
                    url: `/showcase/widget/${id}/header-cover/`,
                    formData,
                    contentType: 'multipart/form-data',
                    signal: requests.signal('showcase-section-widget-header-cover', id)
                });

                if ([200, 201].indexOf(result.status) !== -1) {
                    return result.data;
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },
            // Base
                async addWidgetItem({ widgetId, itemType, id }) {
                    try {
                        const result = await this.$http({
                            method: 'POST',
                            url: `/showcase/widget/${widgetId}/${itemType}/${id}`,
                            signal: requests.signal(`showcase-widget-${itemType}-add`, `${widgetId}-${itemType}-${id}`)
                        });

                        if (result.status === 200) {
                            const { data } = result;

                            return data;
                        }
                    } catch (e) {
                        // onRequestDefaultError(e);
                    }
                },
                async setWidgetItemPosition({ widgetId, itemType, id, position }) {
                    try {
                        const result = await this.$http({
                            method: 'POST',
                            url: `/showcase/widget/${widgetId}/${itemType}/${id}/position/${position}`,
                            signal: requests.signal(`showcase-widget-${itemType}-position`, `${widgetId}-${itemType}-${id}`)
                        });

                        if (result.status === 200) {
                            const { data } = result;

                            return data;
                        } else {
                            onRequestDefaultError({ response: result });
                        }
                    } catch (e) {
                        // onRequestDefaultError(e);
                    }
                },
                async removeWidgetItem({ widgetId, itemType, id }) {
                    try {
                        const result = await this.$http({
                            method: 'DELETE',
                            url: `/showcase/widget/${widgetId}/${itemType}/${id}`,
                            signal: requests.signal(`showcase-widget-${itemType}-remove`, `${widgetId}-${id}`)
                        });

                        if (result.status === 200) {
                            const { data } = result;

                            return data;
                        }
                    } catch (e) {
                        // onRequestDefaultError(e);
                    }
                },

            // Tracks
            async addWidgetTrack({ widgetId, trackId }) {
                return await this.addWidgetItem({ widgetId, id: trackId, itemType: 'track' });
            },
            async setWidgetTrackPosition({ widgetId, trackId, position }) {
                return await this.setWidgetItemPosition({ widgetId, id: trackId, itemType: 'track', position });
            },
            async removeWidgetTrack({ widgetId, trackId }) {
                return await this.removeWidgetItem({ widgetId, id: trackId, itemType: 'track' });
            },

            // Release
            async addWidgetRelease({ widgetId, releaseId }) {
                return await this.addWidgetItem({ widgetId, id: releaseId, itemType: 'release' });
            },
            async setWidgetReleasePosition({ widgetId, releaseId, position }) {
                return await this.setWidgetItemPosition({ widgetId, id: releaseId, itemType: 'release', position });
            },
            async removeWidgetRelease({ widgetId, releaseId }) {
                return await this.removeWidgetItem({ widgetId, id: releaseId, itemType: 'release' });
            },

            // Playlist
            async addWidgetPlaylist({ widgetId, playlistId }) {
                return await this.addWidgetItem({ widgetId, id: playlistId, itemType: 'playlist' });
            },
            async setWidgetPlaylistPosition({ widgetId, playlistId, position }) {
                return await this.setWidgetItemPosition({ widgetId, id: playlistId, itemType: 'playlist', position });
            },
            async removeWidgetPlaylist({ widgetId, playlistId }) {
                return await this.removeWidgetItem({ widgetId, id: playlistId, itemType: 'playlist' });
            },

            // Artist
            async addWidgetArtist({ widgetId, artistId }) {
                return await this.addWidgetItem({ widgetId, id: artistId, itemType: 'artist' });
            },
            async setWidgetArtistPosition({ widgetId, artistId, position }) {
                return await this.setWidgetItemPosition({ widgetId, id: artistId, itemType: 'artist', position });
            },
            async removeWidgetArtist({ widgetId, artistId }) {
                return await this.removeWidgetItem({ widgetId, id: artistId, itemType: 'artist' });
            }
    }
});

export default useShowcaseApi;
